import ko from "knockout";
import ajaxWrapper from "flow/wrappers/ajaxForm";
import register from "flow/knockout/register";
import { IAjaxFormWrapper } from "../wrappers/ajaxForm";

register.registerKnockoutBinding("ajaxForm", {
    init: function (element: HTMLElement, valueAccessor: () => KnockoutObservable<IAjaxFormWrapper>) {
        const value = valueAccessor();

        const wrapper = ajaxWrapper.createWrapper(element);

        if (ko.isObservable(value)) {
            const handle = value;
            handle(wrapper);
        } else {
            throw new Error("ajaxFormBinding only takes an observable for the handle");
        }
    }
});
